@if (visible()) {
  <div class="alert d-flex" [class]="variantClass()" role="alert">
    <div class="flex-grow-1">
      <ng-content />
    </div>
    @if (dismissible()) {
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="close()"
      ></button>
    }
  </div>
}
